import { Section } from './Section';
import './ImpactSection.css';

const valueChainOutcomes = [
  'more predictable procurement from aquaculture and fisheries value chains,',
  'better utilization of processing capacity,',
  'greater continuity of work,',
  'reduced waste from time-sensitive products,',
  'stronger participation in global markets,',
  'and more resilient livelihoods across coastal communities.',
];

export function ImpactSection() {
  return (
    <Section id="impact" tone="muted" className="impact-section">
      <div className="impact-section__intro">
        <h2>Better enterprise decisions. More resilient value chains.</h2>
      </div>
      <div className="impact-section__outcomes">
        <div className="impact-section__enterprise">
          <p className="impact-section__label">Enterprise resilience</p>
          <p>
            The immediate objective is stronger enterprise resilience: less avoidable loss, better
            utilization of inventory and capacity, more reliable fulfillment, faster response to
            disruptions, and more informed decisions under uncertainty.
          </p>
        </div>
        <div className="impact-section__value-chain">
          <p className="impact-section__label">Value-chain resilience</p>
          <p>These enterprise outcomes matter beyond the exporter.</p>
          <p>A more resilient seafood export enterprise can support:</p>
          <ul>
            {valueChainOutcomes.map((outcome) => (
              <li key={outcome}>{outcome}</li>
            ))}
          </ul>
        </div>
      </div>
      <div className="resilience-chain" aria-label="Better enterprise decisions lead to enterprise resilience, value-chain resilience, and livelihood resilience">
        <p>Better enterprise decisions</p>
        <span aria-hidden="true" />
        <p>Enterprise resilience</p>
        <span aria-hidden="true" />
        <p>Value-chain resilience</p>
        <span aria-hidden="true" />
        <p>Livelihood resilience</p>
      </div>
      <p className="impact-section__conclusion">
        The architecture is designed for seafood export first, while remaining applicable to other
        agri-food and export value chains facing similar coordination, perishability, uncertainty,
        and resilience challenges.
      </p>
    </Section>
  );
}
